/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_2fa_DisableInputs */

const cs_settings_profile_2fa_disable = /** @type {(inputs: Settings_Profile_2fa_DisableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vypnout`)
};

const en_settings_profile_2fa_disable = /** @type {(inputs: Settings_Profile_2fa_DisableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disable`)
};

/**
* | output |
* | --- |
* | "Disable" |
*
* @param {Settings_Profile_2fa_DisableInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_2fa_disable = /** @type {((inputs?: Settings_Profile_2fa_DisableInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_2fa_DisableInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_2fa_disable(inputs)
	return cs_settings_profile_2fa_disable(inputs)
});